<div class="modal-header">
  <h4 class="modal-title w-100 text-center">Configuraciones</h4>
</div>
<div class="modal-body">
  <div class="row">
      <div class="col-md-2 d-none d-md-block">
          <img src="assets/images/Icon_Alerta-InformacionAvatar-SyS.png" class="img-fluid" style="max-height: 181px;" alt="info">
      </div>
      <div class="col-12 col-md-10">
          <div [ngSwitch]="origen">
              <ng-container *ngSwitchCase="1">
                  <div class="row">
                      <label for="sede" class="col-12 col-md-2 mb-1 mb-md-0">Sede</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="sedes" bindLabel="M05DES" [(ngModel)]="sedeSeleccionada" (change)="cambiarCarreras($event)">

                          </ng-select>
                      </div>
                  </div>
                  <br>
                  <div class="row">
                      <label for="periodo" class="col-12 col-md-2 mb-1 mb-md-0">Periodo</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="periodos" bindLabel="M19DES" [(ngModel)]="periodoSeleccionado">
                          </ng-select>
                      </div>
                  </div>
                  <br>
                  <div class="row">
                      <label for="periodo" class="col-12 col-md-2 mb-1 mb-md-0">Carrera</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="carreras" bindValue="M04IUP" bindLabel="M02DES" [(ngModel)]="M04IUP">
                          </ng-select>
                      </div>
                  </div>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                  <div class="row">
                      <label for="sede" class="col-12 col-md-2 mb-1 mb-md-0">Sede</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="sedes" bindLabel="M05DES" bindValue="M05COD" [(ngModel)]="M05COD">

                          </ng-select>
                      </div>
                  </div>
                  <br>
                  <div class="row">
                      <label for="anio" class="col-12 col-md-2 mb-1 mb-md-0">Año</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="anios" bindLabel="M18DES" bindValue="M18COD" [(ngModel)]="M18COD" (change)="cambiarPeriodos($event)">

                          </ng-select>

                      </div>
                  </div>
                  <br>
                  <div class="row">
                      <label for="periodo" class="col-12 col-md-2 mb-1 mb-md-0">Periodo</label>
                      <div class="col-12 col-md-8">
                          <ng-select [items]="periodos" bindLabel="M18DES" bindValue="M19COD" [(ngModel)]="M19COD">

                          </ng-select>
                      </div>
                  </div>
              </ng-container>
              <ng-container *ngSwitchCase="3">
                      <div class="col-12 col-md-10">
                        <div class="mb-2 row">
                          <label class="col-12 col-md-2 col-form-label"> Compañia</label>
                          <div class="col-12 col-md-8">
                            <ng-select [items]="companias" bindLabel="CNT05DES" bindValue="CNT05COD" [(ngModel)]='CNT05CODAux' (change)="cambiarSede(CNT05CODAux)"></ng-select>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-10">
                        <div class="mb-2 row">
                          <label class="col-12 col-md-2 col-form-label"> Sedes</label>
                          <div class="col-12 col-md-8">
                            <ng-select [items]="sedes" bindLabel="M05DES" bindValue="M05COD" [(ngModel)]='M05CODAux'></ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-2 row">
                          <label class="col-12 col-md-2 col-form-label"> Año</label>
                          <div class="col-12 col-md-8">
                            <ng-select [items]="anios" bindLabel="M18DES" bindValue="M18COD" [(ngModel)]='M18CODAux' (change)="cambiarPeriodosAux(M18CODAux)"></ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-2 row">
                          <label class="col-12 col-md-2 col-form-label"> Periodo</label>
                          <div class="col-12 col-md-8">
                            <ng-select [items]="periodos" bindLabel="M19DES" bindValue="M19COD" [(ngModel)]='M19CODAux'></ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-10">
                        <div class="mb-2 row">
                          <label class="col-12 col-md-2 col-form-label"> Mostrar Filtros</label>
                          <div class="col-12 col-md-8">
                            <ng-select [(ngModel)]='this.MostrarFiltroPrincipal'>
                              <ng-option [value]="'true'">Si</ng-option>
                              <ng-option [value]="'false'">No</ng-option>
                            </ng-select>
                          </div>
                        </div>
                      </div>

                    <div class="col-12 col-md-10">
                      <div class="mb-2 row">
                        <label class="col-12 col-md-2 col-form-label"> Modulo de inicio</label>
                        <div class="col-12 col-md-8">
                          <ng-select [items]="MenuModulo" bindLabel="S02DES" bindValue="S02COD" [(ngModel)]="ModuloDefault"></ng-select>
                        </div>
                      </div>
                    </div>
              </ng-container>
              <ng-container *ngSwitchCase="4">
                <div class="col-12 col-md-10">
                  <div class="mb-2 row">
                    <label class="col-12 col-md-2 col-form-label"> Compañia</label>
                    <div class="col-12 col-md-8">
                      <ng-select [items]="companias" bindLabel="CNT05DES" bindValue="CNT05COD" [(ngModel)]='CNT05COD' (change)="cambiarSede(CNT05CODAux)"></ng-select>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-10">
                  <div class="mb-2 row">
                    <label class="col-12 col-md-2 col-form-label"> Sedes</label>
                    <div class="col-12 col-md-8">
                      <ng-select [items]="sedes" bindLabel="M05DES" bindValue="M05COD" [(ngModel)]='M05COD'></ng-select>
                    </div>
                  </div>
                </div>
              </ng-container>
          </div>


      </div>
  </div>
</div>
<div class="modal-footer">
  <div class="d-flex flex-column flex-sm-row justify-content-sm-end gap-2 w-100">
      <button type="button" (click)="guardarConfiguracion()"
          class="btn btn-success btn-label waves-light"><i
              class="fas fa-save label-icon"></i> Guardar</button>
      <button type="button" (click)="activeModal.dismiss()"
          class="btn btn-info btn-label waves-light"><i
              class="fas fa-sign-out-alt label-icon"></i> Salir</button>
  </div>
</div>